import { useState } from "react";
import axios from "axios";

function useGetTeams() {
  const [loadingTeam, setLoading] = useState(false);

  const getTeams = async () => {
    try {
      setLoading(true);
      const BEARER_TOKEN = "Bearer " + window.localStorage.getItem("jwt");
      const GET_TEAM_URL = process.env.REACT_APP_URL_API + "/teams";
      const teamResponse = await axios.get(GET_TEAM_URL, {
        headers: { Authorization: BEARER_TOKEN },
      });
      return teamResponse?.data;
    } catch (e) {
      console.log(e?.response);
      return e?.response;
    } finally {
      setLoading(false);
    }
  };

  return { loadingTeam, getTeams };
}

export default useGetTeams;
